import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const token = ref(localStorage.getItem('token') || '')
  const userInfo = ref(JSON.parse(localStorage.getItem('userInfo') || 'null'))

  const isLoggedIn = ref(!!token.value)

  function login(tokenValue, userInfoValue) {
    token.value = tokenValue
    userInfo.value = userInfoValue
    isLoggedIn.value = true
    localStorage.setItem('token', tokenValue)
    localStorage.setItem('userInfo', JSON.stringify(userInfoValue))
  }

  // 从登录响应中设置用户信息
  function setUserInfoFromLogin(data) {
    const userInfoValue = {
      name: data.name,
      avatar: data.avatar,
      username: data.username || data.name
    }
    login(data.token, userInfoValue)
  }

  function logout() {
    token.value = ''
    userInfo.value = null
    isLoggedIn.value = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  return {
    token,
    userInfo,
    isLoggedIn,
    login,
    logout,
    setUserInfoFromLogin
  }
})

